/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./styles.css";
import { connect } from "react-redux";
import { TOASTER_HIDE, toaster_s, toaster_e, toaster_w } from "../../constant";
import { FiCheckCircle, FiAlertTriangle, FiXCircle, FiX } from "react-icons/fi";

function normalizeDescription(description) {
  if (Array.isArray(description)) {
    return description.filter(Boolean);
  }
  if (typeof description === "string" && description.trim()) {
    return description.split(/<br\s*\/?>/i).map((s) => s.trim()).filter(Boolean);
  }
  return [];
}

function statusMeta(type) {
  if (type === toaster_s) {
    return {
      tone: "success",
      label: "Success",
      Icon: FiCheckCircle,
    };
  }
  if (type === toaster_e) {
    return {
      tone: "error",
      label: "Failed",
      Icon: FiXCircle,
    };
  }
  if (type === toaster_w) {
    return {
      tone: "warning",
      label: "Notice",
      Icon: FiAlertTriangle,
    };
  }
  return {
    tone: "info",
    label: "Update",
    Icon: FiAlertTriangle,
  };
}

const Toaster = (props) => {
  const { toaster, hideToaster } = props;
  const { show, type, heading, description, autoHide } = toaster;
  const lines = normalizeDescription(description);
  const { tone, label, Icon } = statusMeta(type);
  const title = heading || label;

  useEffect(() => {
    if (!show || !autoHide) return undefined;
    const timer = setTimeout(() => hideToaster(), 5200);
    return () => clearTimeout(timer);
  }, [show, autoHide, type, heading, description, hideToaster]);

  if (!show) return null;

  return (
    <div
      className={`dt-toast dt-toast--${tone}`}
      role="status"
      aria-live="polite"
    >
      <div className="dt-toast__accent" aria-hidden="true" />
      <div className="dt-toast__icon" aria-hidden="true">
        <Icon size={20} />
      </div>
      <div className="dt-toast__body">
        <p className="dt-toast__eyebrow">{label}</p>
        <p className="dt-toast__title">{title}</p>
        {lines.length > 0 ? (
          <div className="dt-toast__lines">
            {lines.map((item, i) => (
              <p key={`${item}-${i}`} className="dt-toast__line">
                {item}
              </p>
            ))}
          </div>
        ) : null}
      </div>
      <button
        type="button"
        className="dt-toast__close"
        onClick={() => hideToaster()}
        aria-label="Dismiss notification"
      >
        <FiX size={16} />
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  toaster: state.toaster,
});

const mapDispatchToProps = (dispatch) => ({
  hideToaster: () =>
    dispatch({
      type: TOASTER_HIDE,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Toaster);
